import React from 'react';
import {map as _map} from "lodash";
import Select from "../../state/Select";
import {connect} from '@gisatcz/ptr-state';

const AttributesList = (props) => {
	return (
		<div className="eo4sdDrrInsarMyanmar20-attributes-list">
			{
				_map(props.attributeGroups, (group, index) => {
					return (
						<div key={index} className="eo4sdDrrInsarMyanmar20-attributes-list-group">
							{group.title ? <h5>{group.title}</h5> : null}
							{group.subtitle ? <div className="eo4sdDrrInsarMyanmar20-attributes-list-group-subtitle">{group.subtitle}</div> : null}
							{
								_map(group.attributes, (item, index) => {
									return (
										<div key={index} className="eo4sdDrrInsarMyanmar20-attributes-list-rec">
											<div>{item.name || item.key}</div>
											<span>{item.value}</span>
											{!props.withoutUnits && <span>{item.unit ? item.unit : null}</span>}
										</div>
									);
								})
							}
						</div>
					);
				})
			}
		</div>
	);
}

const mapStateToProps = (state, ownProps) => {
	return {
		attributeGroups: Select.specific.eo4sdDrrInsarMyanmar20.getDataForAttributesList(state, ownProps.featureProperties)
	};
};

export default connect(mapStateToProps)(AttributesList);